<template>
  <div
    v-if="packageItems && packageItems.length"
    class="flex flex-col gap-4"
  >
    <ProductAnchorTitle :title="$t('Delivery Package')" />
    <IconicList
      :items="packageItems"
    />
  </div>
</template>
<script lang="ts">

import type { PropType } from 'vue';
import { ListItemIcon, LIST_ITEM_ICON_COLOR_VALUES } from '~/components/atoms/IconicListItem/IconicListItemTypes';
import type { ProductLocalisedAttributes } from '~~/types/product/attribute/ProductLocalisedAttributes';

export default defineComponent({
  name: 'DeliveryPackage',

  props: {
    deliveryPackage: {
      type: Array as PropType<ProductLocalisedAttributes['deliveryPackage']>,
      default: () => {

        return [];
      
      },
    },
  },
  setup(props) {

    const packageItems = computed(() => props.deliveryPackage?.flatMap((localisedValues) =>
      localisedValues.values.map((item) => ({
        icon: ListItemIcon.checkmark,
        iconColor: LIST_ITEM_ICON_COLOR_VALUES.black,
        text: item,
      })),
    ));

    return {
      packageItems,
    };
  
  },
});

</script>
